import HeadNav from "../../components/HeadNav";
import ListEmpty from "../../components/ListEmpty";
import {fmDate, showTotalData} from "../../tools";
import {setUnit1} from "../../tools/chain";

export default {
  name: "CustodyIncome",
  components: {
    HeadNav,
    ListEmpty
  },
  data(){
    return{
      confirmButton:false,
      formData:{
        depositNumber:0,
        withDrawTime:'',
        depositTime:'',
        withDrawNumber:0,
        canWithdrawDailyIncomeArr:'',

      },
      depositLog:[
        {
          depositTime:3432,
          depositNumber:123
        },      {
          depositTime:3432,
          depositNumber:123
        },      {
          depositTime:3432,
          depositNumber:123
        },
      ]
    }
  },
  mounted(){
this.formData.depositNumber=this.$route.params.depositNumber;
this.formData.withDrawTime=this.$route.params.withDrawTime;
this.formData.depositTime=this.$route.params.depositTime;
this.formData.withDrawNumber=this.$route.params.withDrawNumber;
this.formData.canWithdrawDailyIncomeArr=this.$route.params.canWithdrawDailyIncomeArr;
console.log('ceshi',this.formData)
  },
  method:{
    showTotalData(data){
      return showTotalData(data)
    },
    fmDate(data){
      return fmDate(data)
    },
    setUnit1(data){
      return setUnit1(data)
    },
  }
}
